import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const LABELS = {
    '': 'Accueil',
    'informatique': 'Informatique',
    'telephonie': 'Téléphonie',
    'internet': 'Internet',
    'logiciel': 'Logiciels',
    'dev': 'Développement web',
    'cours': 'Cours & Formations',
    'nas': 'NAS & Sauvegardes',
    'pc-portable': 'PC portables',
    'pc-fixe': 'PC de bureau',
    'mentionlegal': 'Mentions légales',
};

const BASE = 'https://amservices.eu';

export default function BreadcrumbsSchema() {
    const { pathname } = useLocation();              // ex: "/telephonie"
    const parts = pathname.replace(/^\/|\/$/g, '').split('/'); // ["telephonie"]
    const items = [];
    let acc = '';

    // Accueil
    items.push({
        '@type': 'ListItem',
        position: 1,
        name: LABELS[''] || 'Accueil',
        item: `${BASE}/`,
    });

    // Segments suivants
    parts.forEach((seg, i) => {
        if (!seg) return;
        acc += `/${seg}`;
        items.push({
            '@type': 'ListItem',
            position: i + 2,
            name: LABELS[seg] || seg,
            item: `${BASE}${acc}`,
        });
    });

    const json = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': items,
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(json)}</script>
        </Helmet>
    );
}
